module.exports = {"TXTCLI_Preview":{"id":"TXTCLI_Preview","defaultMessage":"预览"},"TXTCLI_Report_3":{"id":"TXTCLI_Report_3","defaultMessage":"报告"}}